import React, { Component } from "react";
import classNames from "classnames";

import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withStyles } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

const styles = theme => ({
    snackbar: {
        marginBottom: 24
    },
    snackbarContainer: {
        backgroundColor: "#d32f2f"
    },
    snackbarContainerSuccess: {
        backgroundColor: "#43a047"
    },
    snackbarMessage: {
        display: "flex",
        alignItems: "center"
    },
    icon: {
        fontSize: 20
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(4)
    }
});

class SnackbarWrapper extends Component {
    render() {
        const { missing, classes, snackbarOpen, handleSnackbarClose, isSuccess } = this.props;

        return isSuccess ? (
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                className={classes.snackbar}
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}>
                <SnackbarContent
                    className={classes.snackbarContainerSuccess}
                    message={
                        <span className={classes.snackbarMessage}>
                            <CheckCircleIcon className={classNames(classes.icon, classes.iconVariant)} />
                            Your Progress has been Saved.
                        </span>
                    }
                />
            </Snackbar>
        ) : (
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                className={classes.snackbar}
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}>
                <SnackbarContent
                    className={classes.snackbarContainer}
                    message={
                        <span className={classes.snackbarMessage}>
                            <ErrorIcon className={classNames(classes.icon, classes.iconVariant)} />
                            {"You are missing " +
                                missing +
                                " required " +
                                (missing === 1 ? "field" : "fields") +
                                " in this section."}
                        </span>
                    }
                />
            </Snackbar>
        );
    }
}

export default withStyles(styles)(SnackbarWrapper);
